import styled from 'styled-components'

export const RoleRow = styled.div`
  display: grid;
  grid-template-columns: 11rem minmax(0, 1fr) auto;
  gap: 0.75rem;
  align-items: center;
  padding: 0.75rem 0;
  border-top: 1px solid ${(props) => props.theme.forecast.border};
`

export const RoleColumn = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`
